import {
  Box,
  Checkbox,
  Grid,
  InputLabel,
  Typography,
  useTheme,
} from "@mui/material";
import LoginImage from "../../../../../media/images/LoginImage.png";

import React, { useEffect, useRef, useState } from "react";
import CustomButton from "../../../../components/CustomButton";
import { useAppDispatch } from "../../../../../hooks/useRedux";
import {
  changeLoginType,
  changeSignupType,
} from "../../../../../redux/features/settingSlice";
import ArrowLeftSVG from "../../../../../media/images/icons/arrow-left";
import MobileHeader from "../../../../layout/AuthLayout/MobileHeader";
import AuthFooter from "../../../../layout/AuthLayout/Footer";
import DriverSignup from "../DriverSignup";
import LogoImage from "../../../../../media/images/icons/logo.svg";
import LoginIcon from "../../../../../media/images/icons/login-newsvg";
import { Link } from "react-router-dom";
import LoginLink from "../LoginLink";

export default function UserSignupGrid() {
  const appDispatch = useAppDispatch();
  const theme = useTheme();
  const divRef = useRef<HTMLDivElement>(null);
  const [hasScroll, setHasScroll] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (divRef.current && divRef.current.scrollTop > 5) {
        // Do something when scrolled more than 20 pixels
        setHasScroll(true);
      } else {
        setHasScroll(false);
      }
    };

    if (divRef.current) {
      divRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      // Cleanup: remove the event listener when the component unmounts
      if (divRef.current) {
        divRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  return (
    <>
      <MobileHeader
        title="ثبت نام صاحبین ‌بار و رانندگان"
        hasScroll={hasScroll}
      />
      <Box
        ref={divRef}
        sx={{
          flex: 1,
          // border: "4px solid green",
          overflowY: "auto",
        }}
      >
        <Grid
          container
          sx={{
            height: "100%",
          }}
        >
          <Grid
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              paddingTop: "12px",
              paddingX: {
                xs: "8px",
              },
            }}
            xs
            sm
            md={8}
            lg={8}
            item
          >
            {/* <MobileHeader /> */}
            <Box
              sx={{
                width: "100%",
                flex: 1,
                alignSelf: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  marginX: "auto",
                  width: {
                    xl: "40%",
                    lg: "60%",
                    md: "80%",
                    xs: "100%",
                  },
                }}
              >
                <Box
                  sx={{
                    mb: "16px",
                    justifyContent: "space-between",
                    alignItems: "center",
                    display: {
                      xs: "flex",
                      md: "none",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: "16px",
                    }}
                    color={"primary.main"}
                  >
                    ثبت‌نام صاحبین بار و رانندگان
                  </Typography>

                  <Typography
                    onClick={() => appDispatch(changeSignupType())}
                    color={"secondary.main"}
                    sx={{
                      cursor: "pointer",
                    }}
                  >
                    شرکت حمل و نقل هستید؟{" "}
                  </Typography>
                </Box>
                <DriverSignup />

                <LoginLink />
              </Box>
            </Box>
            {/* <AuthFooter /> */}
            <Box
              sx={{
                backgroundColor: {
                  md: "background.default",
                  width: "fit-content",
                  marginX: "auto",
                },
                padding: "4px",
                borderRadius: "4px",
              }}
            >
              <Typography variant="body2" color="textSecondary" align="center">
                © 2024 - تمام حقوق برای این نرم افزار محفوظ و متعلق به{" "}
                <Typography
                  component="span"
                  variant="body2"
                  color="secondary.main"
                >
                  شرکت کارن ترابر خلیج فارس
                </Typography>{" "}
                می‌باشد.
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            lg={4}
            sx={{
              // border: "5px solid gray",
              backgroundImage: `url(${LoginImage})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              display: {
                xs: "none",
                md: "flex",
              },
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                width: "100%",
                textAlign: "center",
                paddingY: "16px",
                paddingX: "10px",
                position: "relative",
                maxWidth: {
                  xl: "45%",
                  lg: "65%",
                  md: "80%",
                },
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  backgroundColor: "background.default",
                  opacity: "0.9",
                  borderRadius: "16px",
                }}
              ></Box>
              <Box
                sx={{
                  position: "relative",
                }}
              >
                <img width={70} src={LogoImage} alt="" />
                <Typography
                  sx={{
                    fontWeight: "900",
                    zIndex: 5,
                  }}
                  variant="h2"
                  color="secondary.main"
                >
                  ثبت نام شرکت حمل و نقل{" "}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "800",
                    color: "textColor.dark",
                    marginTop: "14px",
                  }}
                >
                  شرکت‌های حمل و نقل برای ثبت‌نام از طریق این گزینه اقدام به
                  ثبت‌نام کنند.{" "}
                </Typography>
                <CustomButton
                  justifyContent="space-between"
                  onClick={() => appDispatch(changeSignupType())}
                  title="ثبت نام شرکت حمل و نقل"
                  bgColor="secondary.main"
                  width="100%"
                  fSize="16px"
                  fontWeight={500}
                  px="10px"
                  py="12px"
                  borderRadius="10px"
                  color="lightStatic.main"
                  icon2={<ArrowLeftSVG size={32} />}
                  mt="16px"
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
